export default __webpack_public_path__ + "static/media/bloom-circle.ff37dce8.svg";